$(document).ready(function () {
    // Function to calculate the incremented value based on the current date
    function getIncrementedValue(initialValue) {
        var startDate = new Date("2025-02-04"); // Set your start date for counting
        var currentDate = new Date();
        var timeDifference = currentDate - startDate;
        var daysPassed = Math.floor(timeDifference / (1000 * 3600 * 24)); // Convert milliseconds to days

        // Add 97 per day to the initial value
        var incrementPerDay = 97;
        return initialValue + (daysPassed * incrementPerDay);
    }

    // Animate the count in the main section
    $(".count").each(function () {
        var initialValue = parseInt($(this).data("value").replace(/,/g, ""), 10); // Remove commas if any
        var updatedValue = getIncrementedValue(initialValue); // Get incremented value

        // Animate the counter with the incremented value
        $(this).prop("Counter", 0).animate({
            Counter: updatedValue
        }, {
            duration: 1000,
            easing: "swing",
            step: function (now) {
                // Format the number with commas
                $(this).text(Math.ceil(now).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
            }
        });
    });

    // Animate the carbon number (if applicable) inside the dropdown or content section
    $(".carbon-numbers").each(function () {
        var initialValue = parseInt($(this).data("value").replace(/,/g, ""), 10); // Get value from data-value attribute
        var updatedValue = getIncrementedValue(initialValue); // Get incremented value

        $(this).find(".carbon-number").prop("Counter", 0).animate({
            Counter: updatedValue
        }, {
            duration: 1000,
            easing: "swing",
            step: function (now) {
                // Format the number with commas
                $(this).text(Math.ceil(now).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
            }
        });
    });

    // Trigger number animation on click
    $(document).on("click", ".carbon-toggle, .carbon-col-wrapper", function (event) {
        event.stopPropagation();
        
        $(".carbon-numbers").each(function () {
            var initialValue = parseInt($(this).data("value").replace(/,/g, ""), 10); // Get value from data-value attribute
            var updatedValue = getIncrementedValue(initialValue); // Get incremented value
            $(this).find(".carbon-number").prop("Counter", 0).animate({
                Counter: updatedValue
            }, {
                duration: 1000,
                easing: "swing",
                step: function (now) {
                    // Format the number with commas
                    $(this).text(Math.ceil(now).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                },
                start: function () {
                    $("body").toggleClass("carbon-popped");
                    sectionsHeight();
                }
            });
        });
    });

    $(document).on("click", function () {
        if ($("body").hasClass("carbon-popped")) {
            $(".carbon-dropdown").stop().animate({ height: "0px" }, 1000, "swing", function () {
                $("body").removeClass("carbon-popped");
                sectionsHeight();
            });
        }
    });

    $(document).on("click", ".carbon-dropdown", function (event) {
        event.stopPropagation();
    });
});


function sectionsHeight() {
    var windowHeight = window.innerHeight;
    
    $(".carbon-dropdown").css("height", windowHeight);
    $(".carbon-height").css("height", windowHeight);

    if ($("body").hasClass("carbon-popped")) {
        $("#MainContent").css("padding-top", windowHeight);
    } else {
        $("#MainContent").css("padding-top", 0);
    }
}


// function sectionsHeight() {
  
//     var headerHeight = $("#shopify-section-header").height();
  
//     var 

  // $(".carbon-content").innerHeight();
    
//     // Ensure `annoucementHeight` and `shippingFreeHeight` are defined
//     var annoucementHeight = $("#announcement-bar").outerHeight() || 0;
//     var shippingFreeHeight = $("#fsb_container").outerHeight() || 0;
    
//     var recycleDropdownHeight2 = recycleDropdownHeight - annoucementHeight;
    
//     if ($("#fsb_container").length) {
//         recycleDropdownHeight2 -= shippingFreeHeight;
//     }

//     $(".carbon-dropdown").css("height", recycleDropdownHeight);
//     $(".carbon-height").css("height", recycleDropdownHeight2);

//     if ($("body").hasClass("carbon-popped")) {
//         if ($(".index-page").length) {
//             $("#MainContent").css("padding-top", recycleDropdownHeight);
//         } else {
//             headerHeight += recycleDropdownHeight;
//             $("#MainContent").css("padding-top", headerHeight);
//         }
//     } else {
//         if ($(".index-page").length) {
//             headerHeight = annoucementHeight;
//         } else {
//             headerHeight += annoucementHeight;
//             if ($("#fsb_container").length) {
//                 headerHeight += shippingFreeHeight;
//             }
//         }
//         $("#MainContent").css("padding-top", headerHeight);
//     }
// }

